import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import LinkComponent from "@Components/Link";
import { generateSubCategoryLink } from "@Components/shop-pop-out/ShopPopOut";
import classes from "./MenuLinks.module.scss";

function L2MenuLinks({ l2CategoryData, backFromL2, handleClose }: any) {
  return (
    <div className={classes["shop-by"]}>
      <div className={classes["l2Header"]} onClick={backFromL2}>
        <ChevronLeft className={classes["chevronLeft"]} />
        <span>
          <h3>{l2CategoryData?.title}</h3>
        </span>
      </div>
      {l2CategoryData.menus?.items?.map((item: any) => (
        <LinkComponent
          href={generateSubCategoryLink(l2CategoryData?.link ?? "", item?.link)}
          key={item.title}
        >
          <a>
            <div className={classes["list-items"]} onClick={handleClose}>
              <span className={classes["shop-by-link-label"]}>
                {item?.title}
              </span>
              <ChevronRight className={classes["chevronRight"]} />
            </div>
          </a>
        </LinkComponent>
      ))}
    </div>
  );
}

export default L2MenuLinks;
